<template>
  <div class="container container-small">
    <div class="header">
      <itinerary-adv-form action="/pl/site/dla-pasazera/informacje/wyszukiwarka-polaczen.html">
      </itinerary-adv-form>
    </div>
  </div>
</template>
<script>
import ItineraryAdvForm from "../components/forms/itinerary-adv-form-module";

export default {
  name: 'section-header',
  components: {ItineraryAdvForm},
  data() {
    return {}
  }
}
</script>